<!-- prettier-ignore -->

<div class="action-buttons-container" [ngClass]="{'no-touch': disableTouch()}">
    @if (!isTechEditMode() && !isTechMode()){
        @if(!isLoadFromApi()){
            <button class="send-map-button" (click)="sendRoute()">{{(!authService.userValue ? 'Enviar Ruta' : 'Guardar Ruta') | translate}}</button>
        }
        @else {
            <button class="send-map-button" (click)="sendRoute()">{{ 'Detalles Ruta' | translate }}</button>
        }
    }

   @if(isTechMode()){
        <button class="send-map-button" (click)="saveRoute()">{{('Guardar Ruta recomendada') | translate}}</button>
        <button class="send-map-button" (click)="sendRoute()">{{('Enviar Ruta por correo') | translate}}</button>
   }

    <!-- <button class="send-map-button" (click)="downloadRoute()">{{('Descargar Ruta') | translate}}</button> -->


    <button (click)="changeStartEndLocation()">{{ 'Cambiar punto inicio/final' | translate }}</button>
</div>